import { render, staticRenderFns } from "./stardetail.vue?vue&type=template&id=3c9607d6&scoped=true&"
import script from "./stardetail.vue?vue&type=script&lang=js&"
export * from "./stardetail.vue?vue&type=script&lang=js&"
import style0 from "./stardetail.vue?vue&type=style&index=0&id=3c9607d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9607d6",
  null
  
)

export default component.exports